import React, { useState, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import styles from "../POIList/POIList.module.css";
import {
    DefaultButton,
    PrimaryButton,
    IStackTokens,
    Dialog,
    DialogType,
    DialogFooter,
} from "@fluentui/react";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import strings from "../../../loc/strings";

initializeIcons();

const stackTokens: IStackTokens = { childrenGap: 20 };

function ExistsDialog(props: any) {
    const auth = useAuth();

    const handleSubmit = (event: any) => {
        event.preventDefault();
    }

    const handleDialogCloseExists = () => {
        props.handleActionExist('existsClose');
        props.setDialogIsHiddenExists(true);
    };

    const handleDialogSaveExists = () => {
        props.handleActionExist('existsSave');
        props.setDialogIsHiddenExists(true);
    };

    // Dialog Edit Contac
    const dialogContentPropsEdit = {
        type: DialogType.normal,
        title: props.title,
    };

    const modalPropsEdit = React.useMemo(
        () => ({
            isBlocking: true,
            className: "ContactConfirm"
        }),
        [],
    );

    return (
        <div className="ContacExists">
            <Dialog
                hidden={props.dialogIsHiddenExists}
                onDismiss={handleDialogCloseExists}
                dialogContentProps={dialogContentPropsEdit}
                modalProps={modalPropsEdit}
                minWidth="560px"
            >
                <div>
                    <p>
                        The email you have entered already exists. Are you sure you want to continue?
                    </p>
                </div>
                <DialogFooter>
                    <PrimaryButton data-testid="save-confirm" onClick={handleDialogSaveExists} text="Save" />
                    <DefaultButton onClick={handleDialogCloseExists} text="Cancel" />
                </DialogFooter>
            </Dialog>
        </div>

    );
}

export default ExistsDialog;